/* results_link.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.32 19.89" xml:space="preserve">
            <path class="foreground-gl" d="M10.71.58l3.74,3.75a.72.72,0,0,1,.23.53V19.5a.75.75,0,0,1-.76.75H1.11a.74.74,0,0,1-.75-.75V1.12A.75.75,0,0,1,1.11.36h9.07A.75.75,0,0,1,10.71.58ZM10.2,5.07l3.58,0L10,1.14V4.81A.26.26,0,0,0,10.2,5.07ZM6.91,9.69h5.14V7H6.91Zm0,5.81h5.14V12.8H6.91ZM5.42,6.61a.82.82,0,0,0-1.1.32L3.38,8.62l-.29-.33A.81.81,0,1,0,1.87,9.36l1.27,1.45a.57.57,0,0,0,.93-.1l1.67-3A.83.83,0,0,0,5.42,6.61Zm0,5.44a.81.81,0,0,0-1.1.32l-.94,1.69-.29-.33a.81.81,0,1,0-1.22,1.06l1.27,1.46a.57.57,0,0,0,.93-.1l1.67-3A.82.82,0,0,0,5.42,12.05Z" transform="translate(-0.36 -0.36)"/>
        </svg>
    `
};
